import React, { useEffect, useState } from "react";
import { useLang } from "../../lib/i18n";
import { X } from "lucide-react";

export default function CookieBanner() {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem("intouch.cookies");
    if (!v) setShow(true);
  }, []);

  const close = (decision) => {
    localStorage.setItem("intouch.cookies", decision);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 inset-x-4 md:bottom-6 md:left-6 md:right-auto md:max-w-md z-[60] animate-fade-up"
    >
      <div className="surface-card p-5 md:p-6 relative">
        <button
          data-testid="cookie-close"
          onClick={() => close("dismissed")}
          className="absolute top-3 right-3 text-ink/40 hover:text-ink"
          aria-label="Close"
        >
          <X className="w-4 h-4" strokeWidth={1.5} />
        </button>
        <p className="text-sm text-ink/75 font-light leading-relaxed pr-4">
          {t.cookies.text}
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          <button
            data-testid="cookie-accept"
            onClick={() => close("accepted")}
            className="rounded-full bg-ink text-cream-100 px-5 py-2 text-xs tracking-wide hover:bg-sage-700 transition-colors"
          >
            {t.cookies.accept}
          </button>
          <button
            data-testid="cookie-reject"
            onClick={() => close("necessary")}
            className="rounded-full border border-ink/15 px-5 py-2 text-xs tracking-wide hover:bg-cream-200 transition-colors"
          >
            {t.cookies.reject}
          </button>
        </div>
      </div>
    </div>
  );
}
